import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as summaryValueMapper from './summaryValueMapper';
import SummarySection from '../../components/Summary/SummarySection';
import * as iraAccountActions from '../../actions/iraAccountActions';
import iraBeneficiaryTexts from '../../components/IraAccount/IraBeneficiaryTexts';
import * as beneficiaryTypes from '../../components/IraAccount/IraBeneficiaryRelationshipTypes';
import * as summaryRowTypes from '../../components/Summary/summaryRowTypes';

export const parseDate = (dateValue) => {
  const d = dateValue ? dateValue.toString().slice(0, 10).split('-') : [];
  return d.length === 3 ? `${d[1]}/${d[2]}/${d[0]}` : '';
};

export class SummaryIRAAccountContainer extends React.Component {
  componentDidMount() {
    if (!this.props.iraAccount) {
      this.props.actions.fetchIraAccount(this.props.applicationId, this.props.authToken);
    }
  }

  render() {
    return (
      <SummarySection {...this.props} />
    );
  }
}

SummaryIRAAccountContainer.propTypes = {
  actions: PropTypes.shape({
    fetchIraAccount: PropTypes.func.isRequired,
  }).isRequired,
  applicationId: PropTypes.string.isRequired,
  authToken: PropTypes.string.isRequired,
  iraAccount: PropTypes.shape(),
};

export const getBeneficiaryRelationship = (relationshipTexts, relationshipCode) => {
  return summaryValueMapper.getTextFromValue(relationshipTexts, relationshipCode || '');
};

export function mapIRABeneficiariesInfo(iraAccount, hasFutures, hasEquities) {
  let iraAccountInformation = [];
  const hasEquitiesAndFutures = hasFutures && hasEquities;
  const hasOnlyFutures = hasFutures && !hasEquities;
  if (iraAccount && iraAccount.iraBeneficiaries && iraAccount.iraBeneficiaries.length > 0 && !hasOnlyFutures) {
    let primaryCount = 0;
    iraAccount.iraBeneficiaries.forEach((beneficiary, index) => {
      primaryCount += beneficiary.type === 'primary' ? 1 : 0;
      const newIndex = beneficiary.type === 'primary' ? index : (index - primaryCount);
      const beneficiaryText = beneficiary.type.charAt(0).toUpperCase() + beneficiary.type.slice(1);
      iraAccountInformation = iraAccountInformation.concat([
        {
          keyType: summaryRowTypes.SUMMARY_ROW_EDIT,
          valueType: summaryRowTypes.SUMMARY_ROW_EDIT,
          key: hasEquitiesAndFutures ? `${beneficiaryText} Beneficiary #${newIndex + 1} - Equity IRA` :
          `${beneficiaryText} Beneficiary #${newIndex + 1}`,
          value: '',
        },
      ]);
      iraAccountInformation = iraAccountInformation.concat([
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Full Name',
          value: beneficiary.fullName,
        },
      ]);
      iraAccountInformation = iraAccountInformation.concat([
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Relationship',
          value: getBeneficiaryRelationship(iraBeneficiaryTexts, beneficiary.relationship),
        },
      ]);
      if (beneficiary.relationship !== beneficiaryTypes.IRA_RELATIONSHIP_ESTATE &&
        beneficiary.relationship !== beneficiaryTypes.IRA_RELATIONSHIP_ORGANIZATIONCHARIRY) {
        iraAccountInformation = iraAccountInformation.concat([
          {
            keyType: summaryRowTypes.SUMMARY_ROW_TXT,
            valueType: summaryRowTypes.SUMMARY_ROW_TXT,
            key: 'Social Security Number',
            value: beneficiary.ssn,
          },
        ]);
        iraAccountInformation = iraAccountInformation.concat([
          {
            keyType: summaryRowTypes.SUMMARY_ROW_TXT,
            valueType: summaryRowTypes.SUMMARY_ROW_TXT,
            key: 'Date of Birth',
            value: parseDate(beneficiary.dateOfBirth),
          },
        ]);
      }
      iraAccountInformation = iraAccountInformation.concat([
        {
          keyType: summaryRowTypes.SUMMARY_ROW_TXT,
          valueType: summaryRowTypes.SUMMARY_ROW_TXT,
          key: 'Percentage',
          value: `${beneficiary.share}%`,
        },
      ]);
    });
  }
  return iraAccountInformation;
}

function mapStateToInitialValues(state) {
  let isLoading = true;
  let iraHasFutures = false;
  let iraHasEquities = false;

  if (state.iraAccountInfo) {
    isLoading = false;
  }

  const iraAccount = state.iraAccount || {};

  if (state.assetClass) {
    iraHasFutures = state.assetClass.assetTypes.includes('futures')
      || state.assetClass.assetTypes.includes('futuresoptions');
    iraHasEquities = state.assetClass.assetTypes.includes('equities');
  }

  return {
    isLoading,
    key: 'iraAccount',
    value: mapIRABeneficiariesInfo(iraAccount, iraHasFutures, iraHasEquities),
    title: 'Beneficiaries',
    editLink: '/ira-account',
    iraHasFutures,
    iraHasOnlyFutures: iraHasFutures && !iraHasEquities,
  };
}

function mapStateToProps(state) {
  const initialValues = mapStateToInitialValues(state);

  return {
    applicationId: state.applicationId,
    authToken: state.authToken,
    isLoading: initialValues.isLoading,
    entity: initialValues.key,
    summaryInfo: initialValues.value,
    title: initialValues.title,
    editLink: initialValues.editLink,
    iraHasFutures: initialValues.iraHasFutures,
    iraHasOnlyFutures: initialValues.iraHasOnlyFutures,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, iraAccountActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryIRAAccountContainer);
